import The_Scout from './GearLight';
import The_Veteran from './GearHeavy';
import The_Stranded from './GearStranded';
import The_Commander from './GearCommander';
import Rock_Lee from './RockLee';
import Gaara from './Gaara';
import Naruto from './Naruto';
import FireFighter from './FireFighter';

export default {
  The_Scout,
  The_Veteran,
  The_Commander,
  The_Stranded,
  Rock_Lee: Rock_Lee().initialize,
  Gaara: Gaara().initialize,
  Naruto: Naruto().initialize,
  FireFighter,
}
